// vendors
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgxPopperModule} from 'ngx-popper';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
// components
import {NavComponent} from './nav/nav.component';
import {TabComponent} from './tab/tab.component';
import {TabGroupComponent} from './tab/tab-group.component';
import {CollapseComponent} from './collapse/collapse.component';
import {PanelComponent} from './collapse/panel.component';
import {LeftNavComponent} from './left-nav/left-nav.component';
import {CascaderComponent} from './cascader/cascader.component';
import {InputComponent} from './input/input.component';
import {TooltipDirective} from './tooltip/tooltip.directive';
import {NotificationComponent} from './notification/notification.component';
import {MapComponent} from './map/map.component';
import {MultiselectComponent} from './multiselect/multiselect.component';
import {DropdownBreadcrumbComponent} from './dropdown-breadcrum/dropdown-breadcrumb.component';
import {FormGroupNavigationComponent} from './form-group-navigation/form-group-navigation.component';
import {GridPaginationComponent} from './grid-pagination/grid-pagination.component';
import {DropdownComponent} from './dropdown/dropdown.component';
import {DatepickerComponent} from './datepicker/datepicker.component';
import {DragAndDropFileComponent} from './drag-and-drop-file/drag-and-drop-file.component';
import {DragAndDropFileDirective} from './drag-and-drop-file/drag-and-drop-file.directive';
import {DropdownButtonComponent} from './dropdown-button/dropdown-button.component';
import {NotificationUpdateComponent} from './notification-update/notification-update.component';
import { LeftNavNewComponent } from './left-nav-new/left-nav-new.component';
import { SwitchComponent } from './switch/switch.component';
import { LoaderComponent } from './loader/loader.component';
import { MultiselectSearchComponent } from './multiselect-search/multiselect-search.component';
import { CalendarComponent } from './calendar/calendar.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { GalleryComponent } from './gallery/gallery.component';
import { LightboxModule } from 'ngx-lightbox';
import { DatepickerTwoComponent } from './datepicker-two/datepicker-two.component';
import { CalendarModule } from 'primeng/calendar';
import { TooltipComponent } from './tooltip-new/tooltip.component';
import { TooltipNewDirective } from './tooltip-new/tooltip-new.directive';
// Pipe
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { LinkifyPipe } from './pipes/linkify.pipe';
import { CopyClipboardDirective } from './pipes/copy-clipboard.directive';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgbDatepickerModule,
		GoogleMapsModule,
		HttpClientModule,
		HttpClientJsonpModule,
		NgxPopperModule.forRoot({}),
		LightboxModule,
		CalendarModule
	],
	declarations: [
		CalendarComponent,
		NavComponent,
		TabGroupComponent,
		CollapseComponent,
		PanelComponent,
		TabComponent,
		LeftNavComponent,
		LeftNavNewComponent,
		CascaderComponent,
		TooltipDirective,
		TooltipNewDirective,
		InputComponent,
		NotificationComponent,
		NotificationUpdateComponent,
		MapComponent,
		MultiselectComponent,
		MultiselectSearchComponent,
		DropdownBreadcrumbComponent,
		FormGroupNavigationComponent,
		GridPaginationComponent,
		DropdownComponent,
		DropdownButtonComponent,
		DatepickerComponent,
		DatepickerTwoComponent,
		DragAndDropFileComponent,
		DragAndDropFileDirective,
		SwitchComponent,
		LoaderComponent,
		GalleryComponent,
		TooltipComponent,
		// Pipes
		SafeHtmlPipe,
		CopyClipboardDirective,
		LinkifyPipe
	],
	exports: [
		CalendarComponent,
		CollapseComponent,
		PanelComponent,
		NavComponent,
		TabGroupComponent,
		TabComponent,
		LeftNavComponent,
		LeftNavNewComponent,
		CascaderComponent,
		TooltipDirective,
		TooltipNewDirective,
		InputComponent,
		NotificationComponent,
		NotificationUpdateComponent,
		MapComponent,
		MultiselectComponent,
		MultiselectSearchComponent,
		DropdownBreadcrumbComponent,
		FormGroupNavigationComponent,
		GridPaginationComponent,
		DropdownComponent,
		DropdownButtonComponent,
		DatepickerComponent,
		DatepickerTwoComponent,
		DragAndDropFileComponent,
		DragAndDropFileDirective,
		SwitchComponent,
		LoaderComponent,
		GalleryComponent,
		TooltipComponent,
		// Pipes
		SafeHtmlPipe,
		CopyClipboardDirective,
		LinkifyPipe
	]
})
export class CvComponentLibraryModule {
}
